import { Navbar } from './modules/layout/Navbar'
import { Content } from './modules/layout/Content'
import { Titlebar } from './modules/layout/Titlebar'
import { Footer } from './modules/layout/Footer'

import { Punker } from './modules/object/Punker'
import { Loading } from './modules/object/Loading'

const C = {
    Navbar,
    Content,
    Titlebar,
    Footer,

    Punker,
    Loading,
}
export default C